// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var STEM__Backend$SmartcutsMacros = require("./STEM__Backend.bs.js");
var STEM__Interfaces$SmartcutsMacros = require("./STEM__Interfaces.bs.js");

function t_encode(v) {
  return [
          "STEM",
          STEM__Interfaces$SmartcutsMacros.signal_encode(v._0),
          Decco.arrayToJson(STEM__Interfaces$SmartcutsMacros.filter_encode, v._1)
        ];
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "STEM") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = STEM__Interfaces$SmartcutsMacros.signal_decode(Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = Decco.arrayFromJson(STEM__Interfaces$SmartcutsMacros.filter_decode, Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* STEM */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var Signal = {
  t_encode: t_encode,
  t_decode: t_decode
};

function t_encode$1(v) {
  return [
          "STEM",
          STEM__Interfaces$SmartcutsMacros.output_encode(v._0)
        ];
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "STEM") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = STEM__Interfaces$SmartcutsMacros.output_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* STEM */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fromSignal(signal) {
  return /* STEM */{
          _0: STEM__Backend$SmartcutsMacros.output(STEM__Backend$SmartcutsMacros.applyFilters(STEM__Backend$SmartcutsMacros.fromSignal(signal._0), signal._1))
        };
}

var DataOutput = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromSignal: fromSignal
};

function request(signal) {
  var payload = JSON.stringify(t_encode(signal));
  return fetch(process.env.HOSTNAME + "/api/data_extraction/", Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(payload), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function (prim) {
                return prim.json();
              }).then(function (json) {
              return Promise.resolve(t_decode$1(json));
            });
}

var WebApi = {
  Signal: Signal,
  DataOutput: DataOutput,
  request: request
};

var schemaVersion = "0.1.0";

var DataRegion;

var DataRecord;

var DataRecordsAndSchema;

var ExportToTable;

exports.schemaVersion = schemaVersion;
exports.WebApi = WebApi;
exports.DataRegion = DataRegion;
exports.DataRecord = DataRecord;
exports.DataRecordsAndSchema = DataRecordsAndSchema;
exports.ExportToTable = ExportToTable;
/* STEM__Backend-SmartcutsMacros Not a pure module */
